export default __webpack_public_path__ + "static/media/dinners.a6e9b2c9.png";